import {toast} from 'react-toastify';
import type {TypeOptions, ToastOptions} from 'react-toastify';

interface ToastifyProps {
    text: string,
    type: TypeOptions,
    config?: ToastOptions,
}

const toastify = ({
    text,
    type,
    config,
}: ToastifyProps) => {
    if (type === 'default') {
        toast(text, config);

        return;
    }

    toast[`${type}`](text, config);
};

export interface ToastLocationState {
    toast: ToastifyProps,
}

export default toastify;
